module.exports = __webpack_public_path__ + "static/media/998195.b57740f2.png";